<!-- 類似券面複数利用制限のダイアログ -->
<template>
  <ItemDialog ref="DialogAlreadyValidatedAnother" image-type="alert">
    <template #content-area>
      <p>他のチケットを使っている間は、このチケットをご使用いただけません。</p>
    </template>
    <template #button-area>
      <ItemButton label="OK" action-type="btn-primary" @clicked="closeDialog" />
    </template>
  </ItemDialog>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";

export default {
  name: "DialogAlreadyValidatedAnother",
  setup() {
    const DialogAlreadyValidatedAnother = ref(null);

    const openDialog = () => {
      DialogAlreadyValidatedAnother.value.open();
    };

    const closeDialog = () => {
      DialogAlreadyValidatedAnother.value.close();
    };

    return {
      DialogAlreadyValidatedAnother,
      openDialog,
      closeDialog,
    };
  },
};
</script>
